import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MiscService } from '../../_service/misc.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LeadsService } from '../../_service/leads.service';
declare var $: any;

@Component({
  selector: 'app-manage-bridge-number',
  templateUrl: './manage-bridge-number.component.html',
  styleUrls: ['./manage-bridge-number.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ManageBridgeNumberComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  bridgeForm: FormGroup;
  perpage: number = 25; bridgeList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; bridge_id= '';
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; submitted: boolean = false; bridge = '';bridge_blank='';myrole:string;
  treatCategory = []; treatCategory_copy = []; lead_category_filter = '';treatments=[];treatments_copy=[];kal_lead=[];kal_lead_copy=[];bridge_no_disabled:boolean = false;
  constructor(private leadapi:LeadsService,public router: Router, private formBuilder: FormBuilder, private sharedapi: SharedService, public miscapi: MiscService) {

    this.bridgeForm = this.formBuilder.group({
      'bridge_name': [null, Validators.required],
      'bridge_number': [null, Validators.required],
      'campaign_name': [null],
      'form_lead_source': [null],
      'catergory_id': [null],
      'treatment_id': [null, Validators.required],
      'leadsource_id':[null, Validators.required],
    });


  }

  get f() { return this.bridgeForm.controls; }

  async updateBridge() {
    this.submitted = true;
    this.loading = true;
    if (this.bridgeForm.invalid) {
      this.loading = false;
      return;
    }

    this.bridgeForm.value.id = parseInt(this.bridge_id);
    await this.miscapi.saveEditBridge(this.bridgeForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.hideModal();
        this.bridgeForm.reset();
        this.sharedapi.presentToast(data.msg);
        this.ngAfterViewInit();
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  ngOnInit(): void {
    this.getTreatmentCategory();
    this.getTreatment();
    this.getKaleyraLeadSource();
    this.myrole = localStorage.getItem('role');
  }

  ngAfterViewInit() {
    this.loadBridgeList(0, this.perpage);
  }

  async loadBridgeList(pageIndex, perpage) {
    this.bridgeList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'bridge=' + this.bridge + '&lead_category_filter=' + this.lead_category_filter;
    this.loading = true; this.loaded = false;
    await this.miscapi.getBridgeList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.bridgeList = data.data;
      } else {
        this.bridgeList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadBridgeList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadBridgeList(event.pageIndex, event.pageSize);
  }

  resetFilters() {
    this.bridge = ''; this.lead_category_filter = '';
    this.loadBridgeList(0, 25);
  }


  showModal(bridgeId) {
    this.bridge_no_disabled = false;
    if(bridgeId){
      this.patchBridgeData(bridgeId);
    }
    $('#myModal').modal();
  }

  hideModal() {
    this.bridge_id='';
    this.bridgeForm.reset();
    $('#myModal').modal('hide');
  }

  async getTreatmentCategory() {
    await this.miscapi.getTreat_Category().subscribe((data: any) => {
      if (data.status) {
        this.treatCategory = data.data;
        this.treatCategory_copy = this.treatCategory;
      } else {
        this.treatCategory = [];
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getTreatment()
  {
      this.leadapi.getTreatments().subscribe((data:any) => {
          if(data.status)
          {
              this.treatments = data.data;
              this.treatments_copy = this.treatments;
          }else{
              this.treatments = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getKaleyraLeadSource()
  {
      this.miscapi.kaleyra_Lead_Source().subscribe((data:any) => {
          if(data.status)
          {
              this.kal_lead = data.data;
              this.kal_lead_copy = this.kal_lead;
          }else{
              this.kal_lead = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }


  async patchBridgeData(bridgeId) {
    await this.miscapi.getBridgeEditData(bridgeId).subscribe((response: any) => {
      if (response.status) {
        this.bridge_no_disabled = true;
        this.bridge_id= response.data.id,
        this.bridgeForm.patchValue({
          'bridge_name': response.data.bridge_name,
          'bridge_number': response.data.bridge_number,
          'campaign_name': response.data.campaign_name,
          'form_lead_source': response.data.form_lead_source,
          // 'bridge_id': response.data.id,
          'catergory_id': response.data.catergory_id,
          'treatment_id': response.data.treatment_id,
          'leadsource_id': response.data.leadsource_id,
        });
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
  setSearchValue(type) {
    if (type == 'leadCategory') {
      $("#leadcategorySearch").val('');
      $("#leadcategorySearch").focus();
      this.treatCategory = this.treatCategory_copy;
    }else if (type == 'treatment') {
      $("#treatmentSearch").val('');
      $("#treatmentSearch").focus();
      this.treatments = this.treatments_copy;
    }else if (type == 'LeadSource') {
      $("#LeadSourceSearch").val('');
      $("#LeadSourceSearch").focus();
      this.kal_lead = this.kal_lead_copy;
    }
  }
  searchOnSelect(searchtText: string, type) {
    if (type == 'leadCategory') {
      this.treatCategory = this.sharedapi.searchData(searchtText, this.treatCategory_copy, "name");
    }else if (type == 'treatment') {
      this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    }else if (type == 'LeadSource') {
      this.kal_lead = this.sharedapi.searchData(searchtText, this.kal_lead_copy, "source_name");
    }
  }
}
